import React, { useEffect, useRef } from 'react';

interface TabContentProps {
  children: React.ReactNode;
  value: string;
  activeTab: string;
}

export const TabContent: React.FC<TabContentProps> = ({ children, value, activeTab }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const isActive = value === activeTab;

  useEffect(() => {
    const element = contentRef.current;
    if (!element) return;

    if (isActive) {
      element.style.display = '';
      element.style.visibility = '';
    } else {
      // Hide but don't unmount
      element.style.display = 'none';
      element.style.visibility = 'hidden';
    }
  }, [isActive]);

  return (
    <div ref={contentRef} style={{ display: isActive ? '' : 'none' }}>
      {children}
    </div>
  );
}; 